import NumberRenderer from 'components/common/NumberRenderer';
import CurrencyRenderer from 'components/common/CurrencyRenderer';
import { FrameIdRenderer } from 'components/common/FrameIdRenderer/FrameIdRenderer';
import { percentageCellRenderer } from 'utils/cellRenderer';
import { ColDef, ICellRendererParams } from 'ag-grid-community';

export const getColumnDefs = (currencyCode: string, localeCode: string): ColDef[] => [
  {
    headerName: 'Media owner',
    field: 'mediaOwner',
    headerTooltip: 'Media owner',
    suppressSizeToFit: true,
  },
  {
    headerName: 'Frame ID',
    field: 'frameId',
    headerTooltip: 'Frame ID',
    cellRenderer: (props: { data?: { frameId: string; isDischarged: boolean } }) => {
      if (!props.data) return null;

      return <FrameIdRenderer frameId={props.data.frameId} isDischarged={props.data.isDischarged} />;
    },
    suppressSizeToFit: true,
  },
  {
    headerName: 'VIOOH ID',
    field: 'vioohId',
    headerTooltip: 'VIOOH ID',
    suppressSizeToFit: true,
  },
  {
    headerName: 'Visual unit ID',
    field: 'visualUnitCode',
    headerTooltip: 'Visual unit ID',
  },
  {
    headerName: 'Address',
    field: 'street',
    headerTooltip: 'Address',
  },
  {
    headerName: 'Postcode',
    field: 'postCode',
    headerTooltip: 'Postcode',
  },
  {
    headerName: 'Coordinates',
    field: 'longitude',
    headerTooltip: 'Coordinates',
    cellRenderer: ({ data }: { data?: { latitude: string; longitude: string } }) => {
      if (!data) return null;

      return (
        <p className="ag-cell-value">
          <span className="text-ellipsis overflow-hidden block">{data.latitude} Lat</span>
          <span className="text-ellipsis overflow-hidden block">{data.longitude} Lon</span>
        </p>
      );
    },
  },
  {
    headerName: 'Availability',
    field: 'availability',
    headerTooltip: 'Availability',
  },
  {
    headerName: 'Impressions',
    field: 'impressions',
    headerTooltip: 'Impressions',
    cellRenderer: ({ value }: ICellRendererParams) => NumberRenderer({ value, localeCode }),
  },
  {
    headerName: 'Price',
    field: 'price',
    headerTooltip: 'Price',
    cellRenderer: ({ value }: ICellRendererParams) => CurrencyRenderer({ value, currencyCode, localeCode }),
  },
  {
    headerName: 'Status',
    field: 'status',
    headerTooltip: 'Status',
    cellRenderer: ({ data }: { data?: { frameId: string; isDischarged: boolean } }) => {
      if (!data) return null;

      return data.isDischarged ? 'Dismounted' : 'Mounted';
    },
    resizable: false,
  },
  {
    headerName: 'Share of time',
    field: 'sot',
    headerTooltip: 'Share of time',
    cellRenderer: (params: ICellRendererParams) => percentageCellRenderer(params, localeCode),
  },
];
